
export default class EmailValidator {

    static isValid(email:string): boolean {
        return email.match('.+@.+[.].+') !== null
    }
}